import React from 'react'
import styled from 'styled-components'
import media from '../../../styles/media'
import shortid from 'shortid'

//Components
import Title from '../../step/title/title'
import SubTitle from '../../step/title/subtitle'

import Button from '../../step/button/button'
import InfoTag from '../../step/infotag/infotag'

const WrapperFeature = styled.div`
  display: flex;
  flex-direction: column;
  ${media.md`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  `};
`
const Feature = styled.button`
  background: transparent;
  border-radius: 45px;
  border: solid 1px #dbdbdb;
  margin-top: 7px;
  margin-bottom: 7px;
  margin-right: 15px;

  cursor: pointer;

  &:focus {
    outline: none;
  }

  ${props => (props.selected ? 'background: #38abe0;  outline: none;' : '')};

  ${media.md`
    margin-top: 15px;
    margin-bottom: 15px;
    margin-right: 30px;
  `};
`

const TextFeature = styled.p`
  margin: 0px;
  opacity: 0.6;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 2.8px;
  text-align: left;
  color: #ffffff;
  padding: 10px 15px;
  ${media.md`
    padding: 20px 30px;
`};
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  ${media.md`
    flex-direction: row; 
    margin-top: 40px;
`};
`
class StepClientNumber extends React.Component {
  state = {
    isError: false
  }

  _toggleFeatures = clientNumber => {
    const { updateClientNumber } = this.props
    updateClientNumber(clientNumber)
  }

  _onNextPress = () => {
    const { clientNumber, nextStep } = this.props
    if (clientNumber === '') {
      this.setState({ isError: true })
    } else {
      nextStep()
    }
  }

  render() {
    const { isError } = this.state
    const { currentStep, clientNumber } = this.props

    const items = [
      { slug: 'Entre 1 y 10 clientes', title: 'Entre 1 y 10 clientes' },
      {
        slug: 'Entre 11 y 50 clientes',
        title: 'Entre 11 y 50 clientes'
      },
      {
        slug: 'Entre 50 y 200 clientes',
        title: 'Entre 50 y 200 clientes'
      },
      {
        slug: 'Más de 200 clientes',
        title: 'Más de 200 clientes'
      }
    ]

    const featureList = items.map(item => (
      <div key={shortid.generate()}>
        <Feature
          selected={item.slug === clientNumber}
          onClick={() => this._toggleFeatures(item.slug)}
        >
          <TextFeature>{item.title}</TextFeature>
        </Feature>
      </div>
    ))
    return 2 != currentStep ? null : (
      <div className="col-md-8 " style={{ margin: 'auto' }}>
        <Title title="Contamos con diferentes soluciones para gestionar tus ingresos y para ello, es importante que nos cuentes cuántos clientes tiene tu empresa. Tu empresa tiene:" />
        <WrapperFeature>{featureList}</WrapperFeature>
        <Wrapper>
          <div>
            <Button onClick={this._onNextPress} title="Siguiente" />
            <SubTitle title="O presione ENTER" />
          </div>
          {isError ? <InfoTag message="&times;Seleccione una opción" /> : null}
        </Wrapper>
      </div>
    )
  }
}

export default StepClientNumber



// WEBPACK FOOTER //
// ./src/components/contactus/steps/StepClientNumber.js